import React from 'react';
import SuggestionButton from './SuggestionButton';

/**
 * Suggestions component displays suggested questions for the user.
 *
 * @param {Object} props - Component props
 * @param {Array<string>} props.suggestions - List of suggestion texts
 * @param {Function} props.onSuggestionClick - Callback when suggestion is clicked
 * @param {boolean} props.disabled - Whether suggestions are disabled (loading state)
 * @returns {JSX.Element} Suggestions component
 */
const Suggestions = ({ suggestions, onSuggestionClick, disabled = false }) => {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <div className="talkflow-suggestions">
      <div className="talkflow-suggestions-title">
        <span className="talkflow-suggestions-icon">💡</span>
        Gợi ý cho bạn:
      </div>
      <div className="talkflow-suggestions-list">
        {suggestions.map((suggestion, index) => (
          <SuggestionButton
            key={index}
            suggestion={suggestion}
            onClick={onSuggestionClick}
            index={index}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
};

export default Suggestions;
